// Shared table look for the two loyalty tables (points rules + points history).
// `overflowX: auto` both clips the rounded corners and keeps narrow screens scrollable
// instead of overflowing the page.
export const tableContainerSx = { borderRadius: 3, overflowX: 'auto' };

export const tableSx = { minWidth: 520 };

export const headRowSx = { bgcolor: 'grey.100' };

export const headCellSx = { fontWeight: 600, whiteSpace: 'nowrap' };
